"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = toDimensionTypeEnum;
const types_1 = require("../types");
function toDimensionTypeEnum(type) {
    switch (type) {
        case "discrete":
            return types_1.DimensionType.Discrete;
        case "continuous":
            return types_1.DimensionType.Continuous;
        default: {
            const neverType = type;
            throw new Error(`Unknown dimension type ${neverType}`);
        }
    }
}
//# sourceMappingURL=toDimensionTypeEnum.js.map